import * as React from 'react'

import { withFormik } from 'formik'

import { Experience }                            from '../../api'
import loadable                                  from '../hocs/loadable'
import { ExperiencesChunk }                      from './chunks'
import { genValueMapper, proxyFormikSubmission } from './form-utils'
import { emptyExperiences, experiencesSchema }   from './schemas'
import { SimpleSubmitFormWrapper }               from './wrappers'

const formikConfig = {
  validationSchema: experiencesSchema,
  mapPropsToValues: genValueMapper(emptyExperiences),
  handleSubmit:     proxyFormikSubmission,
}

export default loadable(
  withFormik<any, { experience: Experience [] }>(formikConfig)(
    props => (
      <SimpleSubmitFormWrapper {...props}>
        {(inner: any) => <ExperiencesChunk {...inner} />}
      </SimpleSubmitFormWrapper>
    ),
  ),
)



// WEBPACK FOOTER //
// ./src/components/forms/ExperienceEditForm.tsx